<template>
  <div>
    <v-list lines="three" color="transparent">
      <template v-for="(version, index) in versions" :key="version.id">
        <v-divider v-if="index > 0" inset></v-divider>

        <v-list-item>
          <template v-slot:prepend>
            <v-avatar rounded color="surface-light">{{ versions.length - index }}</v-avatar>
          </template>

          <v-list-item-title>{{ getTitle(version, versions.length - index) }}</v-list-item-title>
          <v-list-item-subtitle>{{ getDate(version) }}</v-list-item-subtitle>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import dateService from "@/services/dateService";
import { mapState } from "vuex";

export default {
  name: "DocumentHistory",
  props: {
    versions: Array,
  },
  components: {},

  data() {
    return {
      selectedView: 0,
    };
  },

  computed: {
    ...mapState("userProfile", ["dateFormat"]),
  },

  methods: {
    getTitle(version, index) {
      return version.id === version.latestVersionDocId ? "Latest Version" : `Version ${index}`;
    },
    getDate(version) {
      return dateService.formatDateTime(version.updateDate, this.dateFormat);
    },
  },
};
</script>
